import React, { createContext, useContext, useEffect, useState } from "react";
import ApiFetch from "../services/api.fetch";
import { URLS } from "../utils/url";

interface AgentGroupsContextProviderProps {
  children: any;
}

interface AgentGroupsContextValue {
  agentGroups: any;
  loading: boolean;
  error: any;
}

const AgentGroupsContext = createContext<AgentGroupsContextValue | undefined>(
  undefined
);

export const useAgentGroups = (): AgentGroupsContextValue => {
  const context = useContext(AgentGroupsContext);
  if (!context) {
    throw new Error("Something went wrong");
  }
  return context;
};

export const AgentGroupsContextProvider: React.FC<
  AgentGroupsContextProviderProps
> = ({ children }) => {
  const [agentGroups, setAgentGroups] = useState<any>();
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<any>(null);

  useEffect(() => {
    const getAgentGroups = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await ApiFetch.httpGet(URLS.get.agentGroups.all);
        if (response) {
          setAgentGroups(response);
        }
      } catch (err) {
        setError(err);
      } finally {
        setLoading(false);
      }
    };

    getAgentGroups();
  }, []);

  const value: AgentGroupsContextValue = {
    agentGroups,
    loading,
    error,
  };

  return (
    <AgentGroupsContext.Provider value={value}>
      {children}
    </AgentGroupsContext.Provider>
  );
};
